module.exports = __webpack_public_path__ + "static/media/bookMark.45aadeac.svg";